module.exports = __webpack_public_path__ + "static/media/Buildings.8ef1dff4.png";